module.exports = __webpack_public_path__ + "static/investors-info1-fab7cc36b3973378c4f707f166de1bc2.jpg";